module.exports = __webpack_public_path__ + "static/19-988a874a1bbb04e088aed7b18ef424e6.jpg";